import { Routes, Route } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import Layout from './layouts/Layout'
import Home from './pages/Home'
import Products from './pages/Products'
import ProductDetails from './pages/ProductDetails'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import OrderSuccess from './pages/OrderSuccess'
import Login from './pages/Login'
import Register from './pages/Register'
import ProtectedRoute from './components/ProtectedRoute'
import { useNavigationFix } from './hooks/useNavigationFix'

function App() {
  const navigate = useNavigate()
  
  // Fix browser navigation issues
  useNavigationFix()

  // Listen for auth redirect events
  useEffect(() => {
    const handleAuthRedirect = (event) => {
      navigate(event.detail.path)
    }

    window.addEventListener('auth-redirect', handleAuthRedirect)
    return () => window.removeEventListener('auth-redirect', handleAuthRedirect)
  }, [navigate])

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route
          path="/cart"
          element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Layout>
  )
}

export default App
